module.exports = __webpack_public_path__ + "img/news_01.373d41bb.jpg";